import styled from 'styled-components';

import {
  defaultColor,
  fluidFont,
  font,
} from 'styles/theme';

const getArrowLeft = ({ align }) => {
  if (align === 'end') return 'auto';
  if (align === 'center') return '50%';

  return '12px';
};

export const TooltipText = styled.div`
  width: max-content;
  max-width: min(${({ maw }) => maw || '300px'}, calc(100vw - 16px));
  position: absolute;
  background-color:${defaultColor('richBlack')};
  color: ${defaultColor('white')};
  padding: 8px;
  border-radius: 4px;
  top: ${({ position }) => (position === 'top' ? 'auto' : 'calc(100% + 8px)')};
  bottom: ${({ position }) => (position === 'top' ? 'calc(100% + 8px)' : 'auto')};
  left: ${({ align }) => (align === 'center' ? '50%' : 'auto')};
  right: ${({ align }) => (align === 'end' ? '0' : 'auto')};
  transform: ${({ align }) => (align === 'center' ? 'translateX(-50%)' : 'none')};
  ${({ align }) => align === 'start' && 'left: 0;'}
  z-index: 999;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  will-change: opacity;
  pointer-events: none;

  font-family: ${font('regular')};
  ${fluidFont('10px', '14px')};

  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px;
    border-color: ${({ position }) => (position === 'top'
    ? '#000 transparent transparent transparent'
    : 'transparent transparent #000 transparent')};
    top: ${({ position }) => (position === 'top' ? 'auto' : '-10px')};
    bottom: ${({ position }) => (position === 'top' ? '-10px' : 'auto')};
    left: ${getArrowLeft};
    right: ${({ align }) => (align === 'end' ? '12px' : 'auto')};
    transform: ${({ align }) => (align === 'center' ? 'translateX(-50%)' : 'none')};
  }
`;

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;

  &:hover ${TooltipText},
  &:focus-within ${TooltipText} {
    opacity: 1;
  }
`;
